/* eslint-disable no-param-reassign */
export default {
  loadFromStorage(state) {
    const microserviceToken = localStorage.getItem('microserviceToken');
    const sidenavCollapsed = localStorage.getItem('sidenavCollapsed');

    state.microserviceToken = microserviceToken || '';
    state.sidenavCollapsed = sidenavCollapsed === 'true' || false;
    state.theme = 'light-theme';
  },
  setMicroserviceToken(state, microserviceToken) {
    localStorage.setItem('microserviceToken', microserviceToken);
    state.microserviceToken = microserviceToken;
  },
  setWhizeoToken(state, token) {
    localStorage.setItem('whizeoToken', token);
    state.whizeoToken = token;
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  setClientInfo(state, clientInfo) {
    state.clientInfo = clientInfo;
  },
  setSidenavCollapsed(state, sidenavCollapsed) {
    localStorage.setItem('sidenavCollapsed', sidenavCollapsed);
    state.sidenavCollapsed = sidenavCollapsed;
  },
  setShowTutorial(state, show) {
    state.showTutorial = show;
  },
  setTheme(state, theme) {
    state.theme = theme;
  },
};
